<template>
  <div>
    <span id="labelText">{{ pickerLabel }}</span>
    <v-date-picker mode="multiple" v-model="selectedDates" :disabled-dates='{ weekdays: [1, 7] }' is-inline></v-date-picker>
  </div>
</template>

<script>
/*global JFCustomWidget*/
export default {
  data() {
    return {
      selectedDates: [],
      pickerLabel: '',
      formCalculations: false
    }
  },
  name: 'DatePicker',
  created() {
    JFCustomWidget.subscribe("ready", () => {
      this.pickerLabel = JFCustomWidget.getWidgetSetting('QuestionLabel');
      this.formCalculations = JFCustomWidget.getWidgetSetting('FormCalculations') === "Yes";
      JFCustomWidget.subscribe("submit", () => {
        const msg = {
          //you should valid attribute to data for JotForm
          //to be able to use youw widget as required
          valid: true,
          value: this.formattedDate
        }
        // send value to JotForm
        JFCustomWidget.sendSubmit(msg);
      });
    });
  },
  computed: {
    formattedDate: function () {
      if (this.selectedDates.length > 0) {
        return JSON.stringify(this.selectedDates.map(function (v) { return { Date: v } }));
      }
      return "[]"
    }
  },
  watch: {
    selectedDates: function (val) {
      JFCustomWidget.sendData({ value: this.formCalculations ? val.length : this.formattedDate })
    }
  }
}
</script>
